import React from 'react';

const BillingChart = () => {
  const incomeData = [
    { month: 'Ene', income: 1200000 },
    { month: 'Feb', income: 900000 },
    { month: 'Mar', income: 1500000 },
    { month: 'Abr', income: 1240000 },
    { month: 'May', income: 1800000 },
    { month: 'Jun', income: 2100000 }
  ];

  const maxIncome = Math.max(...incomeData.map(item => item.income));

  return (
    <div className="ml-64 p-6">
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Ingresos mensuales</h3>
        <div className="flex items-end h-64 space-x-2">
          {incomeData.map((item, index) => (
            <div key={index} className="flex-1 flex flex-col items-center">
              <div 
                className="w-full bg-cyan-500 rounded-t hover:bg-cyan-600 transition-colors"
                style={{ height: `${(item.income / maxIncome) * 100}%` }}
              ></div>
              <span className="text-xs text-gray-500 mt-2">{item.month}</span>
              <span className="text-xs font-medium">${(item.income / 1000).toFixed(0)}K</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BillingChart;